import { render, staticRenderFns } from "./App.vue?vue&type=template&id=037506b2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=037506b2&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=037506b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037506b2",
  null
  
)

export default component.exports